export default {
  slug: "pycharm",
  code: "PC",
  label: "PyCharm",
  isIDE: true,
  krakenDir: "PyCharm",
  thumbnailColor: "#FCF84A",
  logoFamily: "ide",
  // The code highlight of the Demo Video banners (Figma "YouTube", "Code
  // highlight color" of the product section).
  codeHighlightColor: "#FCF84A",
};
